var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6,0,0,1.6,-3.2,-3.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,2L8,8L10,8L6,13L2,8L4,8L4,2L8,2Z",
    style: {
      fillRule: "nonzero"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4,20.161L16.129,8L11.2,8L11.2,0L20.8,0C20.818,0 20.835,0.005 20.853,0.01C20.868,0.015 20.883,0.019 20.899,0.021C21.042,0.029 21.179,0.058 21.314,0.102C21.33,0.108 21.345,0.113 21.361,0.118C21.396,0.129 21.431,0.14 21.464,0.155C21.634,0.234 21.795,0.331 21.933,0.469L31.533,10.069C31.67,10.206 31.768,10.368 31.846,10.538L31.899,10.688C31.944,10.822 31.971,10.96 31.979,11.101C31.981,11.117 31.985,11.132 31.99,11.147C31.995,11.165 32,11.182 32,11.2L32,28.8C32,30.565 30.565,32 28.8,32L9.6,32C7.835,32 6.4,30.565 6.4,28.8L6.4,20.161ZM20.8,11.2L20.8,3.2L28.8,11.2L20.8,11.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,19.881,-0.82715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.399,30.087L2.519,30.087L-0.681,24.647L-3.881,30.087L-6.761,30.087L-2.121,22.887L-6.761,15.687L-3.881,15.687L-0.681,21.127L2.519,15.687L5.399,15.687L0.759,22.887L5.399,30.087Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.4b12d5f5.svg";
export { ForwardRef as ReactComponent };